import { storage } from '@v4/login/config';

export const authTokenService = {
    setToken(authToken) {
        window.localStorage.setItem(storage.AUTH_TOKEN, authToken);
    },
    getToken() {
        return window.localStorage.getItem(storage.AUTH_TOKEN);
    },
    removeToken() {
        window.localStorage.removeItem(storage.AUTH_TOKEN);
    },
};
